export const getLocaleName = (locale_mapping) => {
  const hostname = window?.location?.hostname;
  const localeNZ = locale_mapping?.find((loc) => loc.alias === 'nz');

  return localeNZ?.hosts?.indexOf(hostname) !== -1 ? 'NZ' : 'AU';
};
